
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/homepage/solutions/solution-page",
      function () {
        return require("private-next-pages/homepage/solutions/solution-page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/homepage/solutions/solution-page"])
      });
    }
  